export default __webpack_public_path__ + "static/media/gmdHomePageImg.c899aa8a.jpeg";